export default __webpack_public_path__ + "static/media/Knee - Elbow Darkness Removal Kit.d70d57f9.jpg";